<template>
  <loginLayout>
    <div class="login-panl">
      <div class="flex-content-between">
        <h1 class="title">智绘网络 · 用户注册</h1>
        <router-link class="link" to="/login"
          >已有账户请点击这里，立即登录</router-link
        >
      </div>
      <div class="f-wrapper">
        <Input
          class="login-input"
          placeholder="请输入手机号码"
          clearable
          v-model="form.name"
          @on-keyup="form.name = form.name.replace(/[^\d]/g, '')"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <div class="flex-content-between login-pswd">
          <Input
            class="login-input"
            placeholder="请输入验证码"
            clearable
            v-model="form.code"
            @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
            style="width: 200px"
          >
            <template #prefix>
              <img
                class="login-name2"
                src="../../assets/image/user-login-icon3.png"
                alt=""
              />
            </template>
          </Input>
          <Button
              ref="smsBtn"
              class="sms-btn"
              shape="circle"
              height="60px"
              @click="refreshCode"
              :disabled="codeDisabled"
              style="width: 120px"
          >{{text}}</Button>
        </div>
        <Input
          class="login-input login-pswd"
          placeholder="请输入密码"
          type="password"
          clearable
          v-model="form.password"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <Input
          class="login-input login-pswd"
          placeholder="请再次输入密码"
          type="password"
          clearable
          v-model="form.confirmPassword"
        >
          <template #prefix>
            <img
              class="login-name"
              src="../../assets/image/user-login-icon.png"
              alt=""
            />
          </template>
        </Input>
        <div style="margin-top: 20px">
          <Checkbox v-model="agreement" class="color-999 c-check"
            >我已阅读并同意遵守</Checkbox
          >
          <span class="color-2d8cf0 pointer" @click="agreementModel"
            >《网络服务协议》</span
          >
          <span class="color-2d8cf0 pointer" @click="privacyModel"
            >《隐私政策》</span
          >
        </div>
        <Button
          class="login-btn"
          type="primary"
          shape="circle"
          long
          :loading="loading"
          @click="submit"
          >立即注册</Button
        >
      </div>
    </div>
    <!-- 智绘网络服务协议 -->
    <rule-modal
      :show.sync="agreementModelShow"
      :content="agreementRuleContent"
      :title="agreementTitle"
    ></rule-modal>
    <!-- 隐私政策 -->
    <rule-modal
      :show.sync="privacyModelShow"
      :content="privacyRuleContent"
      :title="privacyRuleTitle"
    ></rule-modal>
    <Modal
        v-model="verifyshow"
        title="验证码"
        @on-ok="getCodeEvent"
        @on-cancel="verifyshow = false">
      <div class="verify-info">
        <div class="verify-code">
          <span class="verify-label">验证码</span>
          <div class="verify-block">
            <img id="verificationCode" class="verify-img" @click="refreshCode">
          </div>
        </div>
        <input
            v-model="codeValue"
            class="verify-input"
            placeholder="请输入验证码"
        >
      </div>
    </Modal>
  </loginLayout>
</template>

<script>
import loginLayout from "./components/loginLayout.vue";
import smsBtn from "components/smsBtn.vue";
import { getEncrypt } from "utils/encrypt";
import { getRegisterCode, register } from "api/user.js";
import ruleModal from "components/ruleModal.vue";
import agreement from "assets/rule/agreementRule";
import privacyRule from "assets/rule/privacyRule";

export default {
  name: "sige",
  components: {
    loginLayout,
    smsBtn,
    ruleModal,
  },
  data() {
    return {
      agreement: false,
      form: {
        name: "",
        password: "",
        code: "",
        confirmPassword: "",
      },
      loading: false,
      // 智绘网络服务协议
      agreementModelShow: false,
      agreementRuleContent: "",
      agreementTitle: "",
      // 隐私政策
      privacyModelShow: false,
      privacyRuleContent: "",
      privacyRuleTitle: "",
      codeValue: '',
      verifyshow: false,
      getCodeInterval: null,
      text: "获取验证码",
      codeDisabled: false
    };
  },
  methods: {
    refreshCode() {
      if (!this.form.name || this.form.name === '') {
        return this.$Message.warning('手机号不能为空',)
      }
      this.verifyshow = true
      this.codeValue = ''
      setTimeout(() => {
        document.getElementById('verificationCode').src = `${process.env.VUE_APP_API}cczhweb/sms/register/validateCode?mobile=${this.form.name}`
      }, 0)
    },
    agreementModel() {
      this.agreementModelShow = true;
      if (!this.agreementRuleContent) {
        this.agreementRuleContent = agreement.content;
        this.agreementTitle = agreement.title;
      }
    },
    privacyModel() {
      this.privacyModelShow = true;
      if (!this.privacyRuleContent) {
        this.privacyRuleContent = privacyRule.content;
        this.privacyRuleTitle = privacyRule.title;
      }
    },
    // 获取验证码
    getCodeEvent() {
      if (this.codeValue === '') {
        return this.$Message.warning("图形验证码不能为空！");
      }
      if (!/^1[0-9]{10}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码！");
        this.$refs.smsBtn.reset();
        return;
      }
      getRegisterCode(this.form.name, this.codeValue)
        .then((res) => {
          if (res.code === 200 && res.result) {
            let i = 60;
            this.codeDisabled = true
            this.text = `${i--}秒后再获取`;
            this.getCodeInterval = setInterval(() => {
              if (i <= 1) {
                this.text = "获取验证码";
                clearInterval(this.getCodeInterval);
                this.codeDisabled = false
                return;
              }
              this.text = `${i--}秒后再获取`;
            }, 1000);
          }
        })
        .catch(() => {
          this.$refs.smsBtn.reset();
        });
    },
    // 提交
    submit() {
      if (!this.form.name) {
        this.$Message.warning("请输入手机号码！");
        return false;
      }
      if (!/^1[0-9]{10}$/.test(this.form.name)) {
        this.$Message.warning("请输入正确的手机号码！");
        return false;
      }
      if (!this.form.code) {
        this.$Message.warning("请输入验证码！");
        return false;
      }
      if (!this.form.password) {
        this.$Message.warning("请输入密码！");
        return false;
      }
      if (!this.form.confirmPassword) {
        this.$Message.warning("请再次输入密码！");
        return false;
      } else if (this.form.password !== this.form.confirmPassword) {
        this.$Message.warning("两次密码不正确！");
        return false;
      }
      if (!this.agreement) {
        this.$Message.warning("请仔细阅读并同意协议！");
        return false;
      }
      const data = {
        source: 1,
        siteUrl: "http://domain.hhzh.net/",
        pwd: getEncrypt(this.form.password),
        confirmPwd: getEncrypt(this.form.confirmPassword),
        phoneNumber: this.form.name,
        msgCode: this.form.code,
      };
      this.loading = true;
      register(data)
        .then((res) => {
          this.loading = false;
          const { code, result } = res;
          if (code === 200 && result) {
            this.$Message.success("注册成功！");
            this.$router.replace("/login");
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.login-panl {
  display: block;
  width: 506px;
  height: 615px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: 196px;
  transform: translateY(-50%);
  padding: 30px 63px 125px;
  .link {
    line-height: 60px;
    color: #ff5c35;
    font-weight: 400;
    font-size: 14px;
    margin-right: 16px;
  }
  .title {
    font-size: 16px;
    line-height: 60px;
    font-weight: bold;
    color: #333333;
  }
  .f-wrapper {
    margin-top: 10px;
    .login-name {
      margin-top: 22px;
    }
    .login-pswd {
      margin-top: 30px;
    }
    .login-name2 {
      margin-top: 18px;
    }
    .f-link {
      color: #999999;
    }
    .sms-check {
      cursor: pointer;
      color: #ff5c35;
      font-weight: 400;
    }
  }
  /deep/.c-check {
    .ivu-checkbox {
      margin-right: 10px;
    }
    color: #999999;
  }
  /deep/.login-btn {
    margin-top: 40px;
    height: 60px;
    font-size: 14px;
    font-weight: 400;
  }
  /deep/.login-input {
    .ivu-input {
      height: 60px !important;
      line-height: 60px !important;
      border-radius: 40px;
      padding: 0 30px 0 50px !important;
      font-size: 16px;
      font-weight: 400;
      line-height: 60px;
    }
    .ivu-input-prefix {
      padding-left: 20px;
      width: auto;
      line-height: 60px;
    }
    .ivu-input-icon-clear {
      line-height: 60px;
      font-size: 24px;
    }
  }
}
.verify-info {
  padding: 15px 30px;
}
.verify-label {
  background-color: #f7fafb;
  width: 80px;
  font-size: 14px;
  padding: 0 15px;
  line-height: 58px;
  text-align: center;
}
.verify-code {
  border: 1px solid #e9eaec;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.verify-input {
  display: block;
  width: 100%;
  border: 1px solid #e9eaec;
  border-radius: 6px;
  outline: none;
  padding: 0 20px;
  line-height: 40px;
  box-sizing: border-box;
}
.verify-block {
  display: flex;
  justify-content: center;
  align-items: stretch;
  margin-left: 10px;
}
::v-deep .ivu-modal-content {
  background-color: #fff!important;
}
.sms-btn /deep/ {
  .ivu-btn {
    width: 100%;
    height: 100%;
    background-color: #F85A36;
    color: #fff;
    &:hover{
      border-color: #F85A36;
    }
  }
}
</style>
